import React, { useEffect } from 'react';
import Viewer from 'react-viewer';
import { getFileName } from '@laigu/utils/download-file';
function addClass(elem, className) {
  if (!className) return;

  const els = Array.isArray(elem) ? elem : [elem];

  els.forEach(el => {
    if (el.classList) {
      el.classList.add(className.split(' '));
    } else {
      el.className += ` ${className}`;
    }
  });
}

function removeClass(elem, className) {
  if (!className) return;

  const els = Array.isArray(elem) ? elem : [elem];
  els.forEach(el => {
    if (el.classList) {
      el.classList.remove(className.split(' '));
    } else {
      el.className = el.className.replace(new RegExp(`(^|\\b)${className.split(' ').join('|')}(\\b|$)`, 'gi'), ' ');
    }
  });
}

// 下载图片
async function downloadImg(url) {
  fetch(url).then(response => {
    response.blob().then(myBlob => {
      const href = URL.createObjectURL(myBlob);
      let a = document.createElement('a');
      a.href = href;
      a.download = getFileName(url);
      a.click();
    });
  });
}

const ImageViewer = React.memo(props => {
  const { data, setViewerVisible } = props;
  const { imageList, viewerVisible, activeIndex } = data;

  const hideViewer = () => {
    setViewerVisible(false);
  };

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    if (viewerVisible) {
      removeClass(body, 'hide-image-viewer');
    } else {
      addClass(body, 'hide-image-viewer');
    }
  }, [viewerVisible]);

  return imageList && imageList.length ? (
    <Viewer
      visible={viewerVisible}
      activeIndex={activeIndex}
      onClose={hideViewer}
      onMaskClick={e => {
        const { button } = e;
        switch (button) {
          case 2:
            break;
          default:
            hideViewer();
            break;
        }
      }}
      images={imageList}
      zoomSpeed={0.3}
      defaultScale={1.2}
      customToolbar={toolbars => {
        return toolbars.concat([
          {
            key: 'test',
            render: <i className="react-viewer-icon react-viewer-icon-download" />,
            onClick: activeImage => {
              const { downloadUrl } = activeImage;
              downloadImg(downloadUrl);
            }
          }
        ]);
      }}
    />
  ) : null;
});

export default ImageViewer;
